import { useMemo, useState } from "react";
import cn from "classnames";
import { RateCard } from "./RateCard";
import type { RateBucket, RateRecord } from "./rates.model";
import { BUCKET_LABEL, countByStatus, filterRates } from "./rates.model";

type RatesLibraryProps = {
  rates: RateRecord[];
  onEdit: (rate: RateRecord) => void;
  onDelete: (id: string) => void;
};

export const RatesLibrary = ({ rates, onEdit, onDelete }: RatesLibraryProps) => {
  const [bucket, setBucket] = useState<RateBucket>("all");
  const [query, setQuery] = useState("");
  const counts = countByStatus(rates);
  const shown = useMemo(() => filterRates(rates, { status: bucket, text: query }), [rates, bucket, query]);

  return (
    <div className="rt-pane">
      <div className="rt-states" role="tablist" aria-label="Parsed rate state">
        {(["all", "ready", "review", "rejected"] as RateBucket[]).map((key) => (
          <button
            key={key}
            type="button"
            className={cn("rt-stab", { "is-on": bucket === key })}
            data-rtstate={key}
            role="tab"
            aria-selected={bucket === key}
            onClick={() => setBucket(key)}
          >
            <b>{counts[key]}</b>
            <span>{BUCKET_LABEL[key]}</span>
          </button>
        ))}
      </div>

      <div className="nw-list__hd">
        <div className="pcx__h">{BUCKET_LABEL[bucket]}</div>
        <div className="nw-list__f">
          <label className="nw-search">
            <i />
            <input
              type="text"
              value={query}
              placeholder="Search by port or lane..."
              autoComplete="off"
              onChange={(event) => setQuery(event.target.value)}
            />
          </label>
        </div>
      </div>

      <div className="rt-list">
        {shown.map((rate) => (
          <RateCard key={rate.id} rate={rate} variant="library" onEdit={onEdit} onDelete={onDelete} />
        ))}
      </div>
      {shown.length === 0 && <p className="rt-empty">No rates in {BUCKET_LABEL[bucket]} for this search.</p>}
    </div>
  );
};
